function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#005a83",
  d: "M 9 1 C 6.246094 1 4 3.246094 4 6 C 4 7.199219 4.441406 8.285156 5.148438 9.148438 L 1.023438 13.269531 L 1.726563 13.980469 L 5.851563 9.851563 C 6.714844 10.558594 7.800781 11 9 11 C 11.753906 11 14 8.753906 14 6 C 14 3.246094 11.753906 1 9 1 Z M 9 2 C 11.214844 2 13 3.785156 13 6 C 13 8.214844 11.214844 10 9 10 C 6.785156 10 5 8.214844 5 6 C 5 3.785156 6.785156 2 9 2 Z M 7.5 4 C 7.222656 4 7 4.222656 7 4.5 C 7 4.777344 7.222656 5 7.5 5 C 7.777344 5 8 4.777344 8 4.5 C 8 4.222656 7.777344 4 7.5 4 Z M 10.5 4 C 10.222656 4 10 4.222656 10 4.5 C 10 4.777344 10.222656 5 10.5 5 C 10.777344 5 11 4.777344 11 4.5 C 11 4.222656 10.777344 4 10.5 4 Z M 9 6 C 7.902344 6 7 6.902344 7 8 L 8 8 C 8 7.441406 8.441406 7 9 7 C 9.558594 7 10 7.441406 10 8 L 11 8 C 11 6.902344 10.097656 6 9 6 Z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgNoResults = function SvgNoResults(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18",
    width: 34,
    height: 34,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noResults.04f4cfa3.svg";
export { ForwardRef as ReactComponent };